import { render, staticRenderFns } from "./ServiceDashboardWidget.vue?vue&type=template&id=21f9fb2a"
import script from "./ServiceDashboardWidget.vue?vue&type=script&lang=js"
export * from "./ServiceDashboardWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports